<mh-dashboard-widget-card [ready]="ready()">
  <mh-chart-value-widget
    title="IRO"
    [subtitle]="'commons.reputation' | translate"
    [description]="rawData()?.descriptionKey | translate"
    [percentage]="true"
    [product]="'online'"
    [enabled]="enabled()"
    [value]="displayValue()"
    [loading]="loading()"
    [error]="error()"
    [changePercentage]="changePercentage()"
    [increase]="isIncrease()"
    [route]="'/online/resumen'"
    [demoRoute]="'/plg/online'"
    [chartData]="chartData()"
    [chartOptions]="chartOptions()"
    [gaKey]="gaKey()"
  />
</mh-dashboard-widget-card>
